import React, { FC } from 'react'
import { useNavigate } from 'react-router-dom'

import { Text, TextName } from 'sdk'
import { Button } from 'sdk/button/Button'
import { Pill } from 'sdk/pill/Pill'
import BlueGridContainer from 'components/blue-grid-container/BlueGridContainer'

import classes from './style.module.scss'

export const PartnerProgramFeatureSection: FC = () => {
  const navigate = useNavigate()
  const pillData = [
    'Chip makers and architects',
    'Plugin makers',
    'Algorithm developers',
    'Infrastructure cloud tool developers',
  ]

  return (
    <BlueGridContainer>
      <div className={classes.content}>
        <Text type={TextName.H1} className={classes.title}>
          Be Blazing Fast
        </Text>
        <Text type={TextName.Text} className={classes.subtitle}>
          Collaborate to Accelerated Audio Computing
        </Text>
        <div className={classes.pillsContainer}>
          {pillData.map((text, index) => (
            <Pill key={index} text={text} variant='outline' />
          ))}
        </div>
      </div>
      <div className={classes.buttonContainer}>
        <Button variant='blurred' as='button' onClick={() => navigate('/resources')}>
          Learn more
        </Button>
      </div>
    </BlueGridContainer>
  )
}
